import styled from "styled-components";
import { Tabs } from "antd";

export const HomePageWrapper = styled.div`
  padding: 32px 24px;
  padding-bottom: 0;
  background: #fff;
  font-family: 'Manrope', sans-serif;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const HomePageTitle = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 24px;
  leading-trim: Cap height;
  line-height: 28px;
  letter-spacing: 0%;
  color: #1b2028;
`;
export const HomePageContentWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding-bottom: 24px;
`;
export const HorizondalLine = styled.hr`
  border: 1px solid #dde2e9;
`;
export const PaginationContainer = styled.div`
  margin-top: 1.75rem;
  padding-bottom: 80px;
`;
export const MyTasksCard = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px 24px 8px 24px;
  margin: 24px 0 32px 0;
  box-shadow: 0 1px 2px rgba(16, 30, 54, 0.04);
`;
/* Header row: the page title on the left, the segmented tab control on
   the right — one compact 36px line instead of the old title-over-cards
   stack, so the reclaimed height goes to the content below. */
export const HomeContentColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-width: 0;
  padding-bottom: 14px;
`;
export const TabsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;
export const TabsLeft = styled.div`
  display: flex;
  gap: 16px;
`;
export const TabButton = styled.button`
  padding: 8px 20px;
  border: none;
  border-radius: 8px 8px 0 0;
  background: #fff;
  color: ${({ active }) => (active ? "#054db1" : "#6B7280")};
  font-weight: ${({ active }) => (active ? "600" : "400")};
  font-size: 14px;
  // box-shadow: ${({ active }) =>
    active ? "0 -2px 8px rgba(16,30,54,0.04)" : "none"};
  border-bottom: ${({ active }) =>
    active ? "2px solid #0C53BB" : "2px solid transparent"};
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  outline: none;
`;

export const SortIconColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-right: 1px solid #dde2e9;
  .sort-icon {
    border: none;
    cursor: pointer;
    background: transparent;
    padding: 0;
  }
`;
export const Header = styled.div`
  border-right: 1px solid #dde2e9;
`;
export const UnreadDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0c53bb;
  margin-right: 6px;
  vertical-align: middle;
`;
export const ActionsColumn = styled.div`
  .approved {
    background: #ddf6e9;
    padding: 4px 8px;
    border-radius: 18px;
    color: #16b361;
  }
  .pending {
    background: #dae6f7;
    padding: 4px 8px;
    border-radius: 18px;
    color: #0c53bb;
  }
  .rework {
    background: #ffe4d5;
    padding: 4px 8px;
    border-radius: 18px;
    color: #cd5f24;
  }
  .vaPending {
    background: #fff5d5;
    padding: 4px 8px;
    border-radius: 18px;
    color: #9b7d1c;
  }
  .vbms {
    background: #eedbf6;
    padding: 4px 8px;
    border-radius: 18px;
    color: #8314b3;
  }
  .error {
    background: #f6dbdb;
    padding: 4px 8px;
    border-radius: 18px;
    color: #b31514;
  }
  .expired {
    background: #e9ecf1;
    padding: 4px 8px;
    border-radius: 18px;
    color: #5a6c87;
  }
`;

export const ReviewActionBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`;

export const ReviewActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  border: 1px solid ${({ variant }) => (variant === "primary" ? "#bcd3f2" : "#dde2e9")};
  background: ${({ variant }) => (variant === "primary" ? "#dae6f7" : "#fff")};
  color: ${({ variant }) => (variant === "primary" ? "#0c53bb" : "#5a6c87")};

  &:hover {
    border-color: ${({ variant }) => (variant === "primary" ? "#9dbfe9" : "#c8d0db")};
    background: ${({ variant }) => (variant === "primary" ? "#c9dcf5" : "#f2f5f9")};
    color: ${({ variant }) => (variant === "primary" ? "#0a459d" : "#48566b")};
  }

  &:focus-visible {
    outline: 2px solid #0c53bb;
    outline-offset: 1px;
  }
`;

export const AcknowledgedLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #5a6c87;

  &::before {
    content: "\\2713";
    color: #5a8a5a;
  }
`;

export const TableTdWrapper = styled.div`
  max-width: 300px;
  width: fit-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #1b2028;
`;

/* iOS-style segmented control: a light-grey rounded track, and antd's
   ink bar restyled from a 2px underline into a full-height white pill
   that slides behind the active label (antd already animates the ink
   bar's left/width, so the slide comes for free). */
export const StyledHomeTabs = styled(Tabs)`
  &.ant-tabs {
    flex-shrink: 0;
    min-width: 0;

    .ant-tabs-nav {
      margin: 0;
      padding: 0;
    }

    /* antd draws a full-width hairline under the tab strip; the
       segmented track replaces it. */
    .ant-tabs-nav::before {
      display: none;
    }

    .ant-tabs-nav-list {
      background: #eef0f4;
      border-radius: 8px;
      padding: 2px;
    }

    .ant-tabs-tab {
      position: relative;
      z-index: 1; /* labels sit above the sliding segment */
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      margin: 0;
      padding: 0 16px;
      background: transparent;
      border: none;
      border-radius: 6px;
      min-width: 0;

      .ant-tabs-tab-btn {
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        color: #5a6c87;
        text-shadow: none;
        transition: color 0.15s ease;
      }

      &:hover .ant-tabs-tab-btn {
        color: #1b2028;
      }
    }

    .ant-tabs-tab:focus,
    .ant-tabs-tab:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }

    .ant-tabs-tab div {
      outline: none !important;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #0c53bb !important;
    }

    &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
      display: block;
      top: 2px;
      bottom: auto;
      height: calc(100% - 4px);
      background: #ffffff;
      border-radius: 6px;
      box-shadow: 0 1px 2px rgba(16, 30, 54, 0.12), 0 0 0 1px rgba(16, 30, 54, 0.03);
      z-index: 0;
    }

    &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar-animated {
      transition: left 0.18s ease, width 0.18s ease;
    }
  }
`;

export const TabsContentWrapper = styled.div`
  border-top: 1px solid #e5e8ec;
  padding: 20px 0 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;
